<a class="menu-trigger-page-links" *ngIf="showMenuTrigger && showPageWithLinkMenu" href="javscript:;"
  [class.active]="activeMobileMenu" (click)="activeMobileMenu = !activeMobileMenu"><span></span></a>
<!-- <div class="page-links-holder" *ngIf='showPageWithLinkMenu'> -->
<div class="page-links-holder">
  <div *ngFor="let item of items | rankingNum: 'ranking'" class="page-link {{ item.additionalClass+'-link-holder' }}"
    [ngClass]="{'active': selectedItem == item}">
    <div>
      <a (click)="listClick($event, item)" class="simulation-show" href="javascript:;">{{ item.LinkName }}</a>
    </div>
  </div>
</div>
<div @slideRight *ngFor="let item of items" [ngClass]="{'active': selectedItem == item}"  class="page-holder-container">
  <div *ngIf="item && selectedItem == item" class="page-holder {{ item.additionalClass }}"
    [ngClass]="{'active': selectedItem == item}">


    <app-go-to-project></app-go-to-project>
    <ul class="page">
      <li *ngIf="item && selectedItem == item">
        <!-- <h1>{{ item.autoPlay }}</h1> -->
        <app-gallery @slideRight [galleryId]="'1'" [section]="item.id+'images1'" [autoPlay]="item.autoPlay"
          [type]="'scroll'" [showThumbs]="true" [resizeDrag]="item.resizeDrag"
          class="{{ item.galleryType }}"></app-gallery>
        <!-- [showThumbs]="item.showThumbs" [resizeDrag]="this.resizeDrag" class="{{ item.galleryType }}"></app-gallery> -->
      </li>
      <li>
        <app-n-page-with-link [parentId]=item.id></app-n-page-with-link>
      </li>
    </ul>
  </div>
</div>

